import listService from "../ListService";
import mobileListService from "../mobile/MobileListService";
import constants from "../../constants/Constants";
import mobileConstants from "../../mobile/commons/MobileFormsConstants";

class MobileSyncService {
    
     get sharedAttributes() {
        return [
            {factoryKey: 'control_bullet_text', shared: ['name', 'text']},
            {factoryKey: 'control_button', shared: ['name', 'text']},
            {factoryKey: 'control_captcha', shared: ['name']},
            {factoryKey: 'control_checkbox', shared: ['name', 'text', 'selected']},
            {factoryKey: 'control_checkbox_group', shared: ['name']},
            {factoryKey: 'control_date_input', shared: ['name', 'minYear', 'maxYear', 'format', 'dateValueSpecific', 'showEmpty', 'showNow', 'specificDisplay', 'specific']},
            {factoryKey: 'control_drop_down', shared: ['name']},
            {factoryKey: 'control_file_attachment', shared: ['name', 'buttonLeft', 'buttonPositionLeft', 'buttonLabelAttach', 'buttonLabelDetach']},
            {factoryKey: 'control_horizontal_separator', shared: ['name']},
            {factoryKey: 'control_horizontal_slider', shared: ['name', 'minValue', 'maxValue', 'snapInterval', 'minText', 'maxText']},
            {factoryKey: 'control_large_heading', shared: ['alignCenterSelection', 'alignRightSelection', 'alignLeftSelection','align', 'isHtml', 'name', 'text']},
            {factoryKey: 'control_link', shared: ['name', 'text']},
            {factoryKey: 'control_list', shared: ['name']},
            {factoryKey: 'control_mask_text_input', shared: ['name', 'mask']},
            {factoryKey: 'control_medium_heading', shared: ['alignCenterSelection', 'alignRightSelection', 'alignLeftSelection','align', 'isHtml', 'name', 'text']},
            {factoryKey: 'control_multiple_text_input', shared: ['name', 'text']},
            {factoryKey: 'control_text_input', shared: ['name', 'text']},
            {factoryKey: 'control_numeric_input', shared: ['name']},
            {factoryKey: 'control_numeric_stepper', shared: ['name']},
            {factoryKey: 'control_page_button', shared: ['name', 'text']},
            {factoryKey: 'control_password_input', shared: ['name']},
            {factoryKey: 'control_picture', shared: ['name', 'assetId', 'maintainAspectRatio', 'stretch']},
            {factoryKey: 'control_print_button', shared: ['name', 'text']},
            {factoryKey: 'control_progress_bar', shared: ['name']},
            {factoryKey: 'control_radio_button', shared: ['name', 'text', 'selected']},
            {factoryKey: 'control_radio_button_group', shared: ['name']},
            {factoryKey: 'control_ranking', shared: ['name']},
            {factoryKey: 'control_play_form_button', shared: ['name', 'text']},
            {factoryKey: 'control_play_report_button', shared: ['name', 'text']},
            {factoryKey: 'control_small_heading', shared: ['alignCenterSelection', 'alignRightSelection', 'alignLeftSelection','align', 'isHtml', 'name', 'text']},
            {factoryKey: 'control_small_text', shared: ['alignCenterSelection', 'alignRightSelection', 'alignLeftSelection','align', 'isHtml', 'name', 'text']},
            {factoryKey: 'control_submit_button', shared: ['name', 'text']},
            {factoryKey: 'control_text', shared: ['alignCenterSelection', 'alignRightSelection', 'alignLeftSelection','align', 'isHtml', 'name', 'text']},
            {factoryKey: 'control_text_input', shared: ['name', 'text']},
            {factoryKey: 'control_time_input', shared: ['name', 'hasSeconds', 'is24HourClock', 'timeValueSpecific', 'timeValueType', 'specific', 'showNow', 'showEmpty']},
            {factoryKey: 'control_websignature', shared: ['name', 'buttonPosition', 'buttonPositionAbove', 'buttonLabelSave', 'buttonLabelClear']},
            {factoryKey: 'control_table', shared: ['name','headerTextStyle', 'headerTextWeight', 'headerFontFamily', 'headerTextColor', 'headerBgColor','headerBgColorGradient','normalRowBgColor','alternateRowBgColor','borderStyle','borderColor','cornerRadius','borderSize','backgroundColor','headerFontFamily']}
        ];
    }

    synchronize(model, changed) {
         if (listService.timesWizardCompleted) {
             // immediate control attributes synchronization
             if(listService.mainKind === constants.KIND_MOBILE
                 && model.get('factoryKey') !== mobileConstants.SECTION_FACTORY_KEY) {
                 this.synchronizeDesktopForm(model, model.get('factoryKey'), changed);
             } else if (listService.mainKind !== constants.KIND_MOBILE
                 && model.get('factoryKey') !== mobileConstants.SECTION_FACTORY_KEY
                 && changed.key){
                 this.synchronizeMobileForm(model, model.get('factoryKey'), changed);
             } else if (model.get('factoryKey') === mobileConstants.SECTION_FACTORY_KEY) {
                 // update Section mobile object
                 const mobileSection = listService.getSectionById(model.get('id')).get(model.get('id'));
                 mobileSection[changed.key] = changed.val;
                 listService.updateMobileObject(mobileSection.id, mobileSection);

                 // update Section mobile control
                 const controlSection = mobileListService.getMobileControl(mobileSection.id);
                 controlSection.model.set(changed.key, changed.val, constants.MODEL_SILENT);
                 mobileListService.updateMobileControl(mobileSection.id, controlSection);
                 controlSection.render();
             }
         }
    }

    getSyncRules(factoryKey, changed) {
        return this.sharedAttributes.find(rule => rule.factoryKey === factoryKey && rule.shared.includes(changed.key));
    }

    synchronizeDesktopForm(model, factoryKey, changed) {
        const formControl = listService.getObject(model.get('id'));
        if (this.getSyncRules(factoryKey, changed)) {
            formControl.model.set(changed.key, changed.val, constants.MODEL_SILENT);
            listService.isDirty = true;
        }
    }

    synchronizeMobileForm(model, factoryKey, changed) {
        const mobileControl = mobileListService.getMobileControl(model.get('id'));
        if (mobileControl && this.getSyncRules(factoryKey, changed)) {
            mobileControl.model.set(changed.key, changed.val, constants.MODEL_SILENT);
        }
    }

}

const mobileSyncService = new MobileSyncService();
export default  mobileSyncService;